<template>
  <div v-if="displayStyle === 'cimStyle'">
    <div class="rounded-lg border bg-white shadow-md transition duration-200 ease-in-out transform hover:shadow-lg hover:scale-105 p-4">
      <div class="flex items-center justify-between gap-x-4">
        <div class="flex items-center gap-x-4 flex-1 min-w-0">
          <div class="flex items-center flex-shrink-0">
            <Icon
              :name="getFileIcon(fileModel.name)"
              class="text-primary-500 h-12 w-12"
            />
          </div>
          <div class="flex flex-col flex-1 min-w-0">
            <span
              class="font-bold break-words text-base"
              :title="fileModel.name"
            >{{ fileModel.name }}</span>
            <span
              v-if="fileModel.createdAt"
              class="text-sm text-gray-400 mt-1"
            >
              Uploaded at: {{ formatDate(fileModel.createdAt, TimeStampFormat.DayMonthYear) }}
            </span>
          </div>
        </div>

        <div
          v-if="showActions"
          class="flex gap-x-2 justify-end pt-2 border-t"
        >
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="rounded-lg  border bg-white shadow-md transition duration-200 ease-in-out transform hover:shadow-lg hover:scale-105"
    :class="displayStyle === 'slim' ? 'p-2' : 'p-4'"
  >
    <div class="flex gap-x-1 ">
      <div class="flex items-center">
        <Icon
          :name="getFileIcon(fileModel.name)"
          class="text-primary-500"
          :class="displayStyle === 'slim' ? 'h-6 w-6' : 'h-12 w-12'"
        />
      </div>
      <div
        class="grid grid-cols-1 flex-1 items-center"
        :class="displayStyle === 'slim' ? 'px-2' : 'px-5'"
      >
        <span

          class=" font-semibold break-words text-sm"
          :title="fileModel.name"
        >{{ fileModel.name }}</span>
        <span
          :class="displayStyle === 'slim' ? 'text-xs' : 'text-sm'"
          class="text-gray-500"
        >Uploaded at: {{ formatDate(fileModel.createdAt, TimeStampFormat.DayMonthYear) }}</span>
      </div>
    </div>

    <div
      v-if="showActions"
      class="flex gap-x-2 justify-end pt-2 border-t"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { File } from '~/types/folders'

const showActions = defineModel<boolean>('showActions', { required: true, default: false })

const fileModel = defineModel<File>('file', { required: true })

const { formatDate, TimeStampFormat } = useUtils()

const displayStyle = defineModel<string>('displayStyle', { required: true, default: 'default' })

const getFileIcon = (fileName: string) => {
  const extension = fileName.split('.').pop()?.toLowerCase()

  const iconMap: Record<string, string> = {
    pdf: 'mdi:file-pdf',
    doc: 'mdi:file-word-box',
    docx: 'mdi:file-word-box',
    xls: 'mdi:file-excel-box',
    xlsx: 'mdi:file-excel-box',
    ppt: 'mdi:file-powerpoint-box',
    pptx: 'mdi:file-powerpoint-box',
    jpg: 'mdi:file-image',
    jpeg: 'mdi:file-image',
    png: 'mdi:file-image',
    gif: 'mdi:file-image',
    txt: 'mdi:file-document',
    csv: 'mdi:file-delimited',
    mp3: 'mdi:file-music',
    mp4: 'mdi:file-video',
  }

  return iconMap[extension || ''] || 'mdi:file'
}
</script>
